import { Tool } from './base';

export class CarbonBlackResponseTool extends Tool {
  public readonly toolName = 'CarbonBlack Response';

  public generateSearchPermalink(
    rootURL: string,
    renderedContent: string
  ): string {
    const carbonBlackResponseSearchURI = '#/search?rows=10&q=';
    const encodedRenderedContent = encodeURIComponent(renderedContent);
    return `${rootURL}${carbonBlackResponseSearchURI}${encodedRenderedContent}`;
  }
}
